<script>
import $ from 'jquery'
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import Vue from 'vue'
import StarRating from 'vue-star-rating'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import momentsone from 'moment-timezone'

// import * as EmailValidator from 'email-validator'
const formShape = {
  candidate_name: '',
  candidate_lastname: '',
  candidate_email: '',
  year_of_experience: '',
  month_of_experience: '',
  primarySkils: '',
  secoundarySkills: '',
  comments: '',
  candidate_uniqueid: '',
  candidate_ssn: ''
}

const timezonList = [
  { id: 0, name: 'IST', fullName: 'Asia/Kolkata' },
  { id: 1, name: 'IST', fullName: 'Asia/Calcutta' },
  { id: 2, name: 'EST', fullName: 'America/New_York' },
  { id: 3, name: 'GMT', fullName: 'Europe/London' },
  { id: 4, name: 'CST', fullName: 'America/Chicago' },
  { id: 5, name: 'PST', fullName: 'America/Los_Angeles' },
  { id: 6, name: 'HST', fullName: 'Pacific/Honolulu' },
  { id: 7, name: 'AHST', fullName: 'America/Anchorage' }
]

export const EventBus = new Vue()
export default {
  name: 'add-schedule',
  data () {
    return {
      userid: '',
      form: Object.assign({}, formShape),
      base_urls: BaseURL,
      profiledetails: [],
      editoption: false,
      editoptionssn: false,
      profilesills: [],
      groupeddate: [],
      groupeddatelen: 0,
      pSkils: [],
      postdatas: [],
      postdetails: [],
      startdate: '',
      enddate: '',
      selectpost: '',
      otherEmails: '',
      typetext: '',
      inputs: {
        emails: [],
        invalid: false
      },
      disableasign: true,
      schedule_count: 0,
      shownewdate: false,
      emailval_error: false,
      showRole: false,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      tabOne: true,
      tabTwo: false,
      changed: 0,
      acsallow: false,
      files: [],
      alreadySchedule: [],
      acsscheduleDetail: [],
      otheremailList: [],
      postattachment: [],
      availabledate: [],
      timezoneDates: [],
      alreadyScheduleLength: 0,
      validationerror: false,
      showratingform: false,
      scheduleId: '',
      rating: 3.5,
      shedulesuccess: 0,
      filerequire: 0,
      unique_exist: false,
      unique_required: false,
      unique_invalid: false,
      ssn_exist: false,
      ssn_required: false,
      ssn_invalid: false,
      showone: false,
      istshow: true,
      estshow: false,
      submitted: false,
      previous_schedule_detail_length: 0,
      previous_schedule_detail: [],
      timezone: 'IST',
      activetimezone: '',
      currentTimeZone: momentsone.tz.guess(),
      org_timezone: momentsone.tz.guess(),
      org_timezone_short: '',
      interviewer_timezone: '',
      interviewer_timezone_short: '',
      timezoneApp: '',
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      sections:
      [
        { value: 75, color: '#f39c12' }
      ],
      video: {
        sources: [{
          src: '../../assets/video/video.mp4',
          type: 'video/mp4'
        }],
        options: {
          autoplay: true,
          volume: 0.6,
          poster: '../../assets/video/video.mp4'
        }
      }
    }
  },
  components: {
    StarRating,
    Multiselect
  },
  props: {
    shwovalueAddSchedule: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
    axios.get(BaseURL + '/skills/skills/ios', this.config).then(response => {
      this.pSkils = response.data.all_skill
    }).catch(e => {
    })
  },
  created () {
    var time = new Date()
    var timeZoneOffset = time.getTimezoneOffset()
    console.log(this.currentTimeZone)
    this.timezoneApp = moment.tz.zone(this.currentTimeZone).abbr(timeZoneOffset)
    console.log(this.timezoneApp)
    if (this.timezoneApp === 'EDT') {
      this.timezoneApp = 'EST'
    } else if (this.timezoneApp === 'PDT') {
      this.timezoneApp = 'PST'
    } else if (this.timezoneApp === 'AKDT') {
      this.timezoneApp = 'AHST'
    }
    this.shwovalueAddSchedule = true
    this.posts = JSON.parse(localStorage.getItem('postId'))
    this.interviewer = JSON.parse(localStorage.getItem('viewid'))
    this.userid = JSON.parse(localStorage.getItem('viewid'))
    this.selectpost = JSON.parse(localStorage.getItem('postId'))
    this.startdate = ''
    this.enddate = ''
    $('.custom-file-uploads').removeClass('is-invalid')
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      this.showRole = true
    }
    this.org_timezone_short = this.timezoneApp
    // if (this.org_timezone === 'America/New_York') {
    //   this.org_timezone_short = 'EST'
    // } else {
    //   this.org_timezone_short = 'IST'
    // }
    this.getdata()
    this.getpostdata()
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      candidate_name: {
        required
      },
      candidate_lastname: {},
      candidate_email: {
        required, email
      },
      year_of_experience: {
        required
      },
      month_of_experience: {
        required
      },
      primarySkils: {
        required
      },
      secoundarySkills: {
        // required
      },
      comments: {
        // required
      },
      candidate_uniqueid: {

      },
      candidate_ssn: {

      }
    }
  },
  methods: {
    getEmailInputs (inputs) {
      this.inputs = inputs
    },
    fileUploads (e) {
      $('.custom-file-uploads').removeClass('is-invalid')
      this.files = []
      for (let k = 0; k < e.target.files.length; k++) {
        if (this.showRole) {
          if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf') {
            if (e.target.files[k].size < '2000001') {
              this.files.push(e.target.files[k])
              this.filerequire = 0
            }
          }
        } else {
          if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
            if (e.target.files[k].size < '2000001') {
              this.files.push(e.target.files[k])
              this.filerequire = 0
            }
          }
        }
      }
      $('#files').val('')
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      const formData = new FormData()
      formData.append('image', this.files[0])
      formData.append('sid', 8000000)
      formData.append('candidate_name', 'text')
      if (this.files.length > 0 && this.showRole) {
        axios.post(BaseURL + '/dashboard/add_candidate_resume_new/8000000/text',
          formData, config).then(response => {
          this.form.candidate_email = response.data.email
          this.form.candidate_uniqueid = response.data.candidate_uniqueid
          this.form.candidate_ssn = response.data.candidate_ssn
          if (response.data.details.length > 0) {
            if (response.data.details[0] !== '') {
              this.form.candidate_name = response.data.details[0]
              this.form.candidate_lastname = response.data.details[1]
            } else if (response.data.details[1] !== '') {
              this.form.candidate_name = response.data.details[1]
              this.form.candidate_lastname = response.data.details[2]
            } else {
              this.form.candidate_name = response.data.details[2]
              this.form.candidate_lastname = response.data.details[3]
            }
            if (response.data.candidate_uniqueid.length === 4) {
              this.editoptionssn = true
            }
            if (response.data.candidate_ssn.length === 4) {
              this.editoption = true
            }
            if (this.form.candidate_uniqueid === 'NA' || this.form.candidate_uniqueid === 'Na') {
              this.form.candidate_uniqueid = ''
            }
            if (this.form.candidate_ssn === 'NA' || this.form.candidate_ssn === 'Na') {
              this.form.candidate_ssn = ''
            }
            this.unique_required = false
            this.unique_invalid = false
            this.unique_exist = false
            this.ssn_exist = false
            this.ssn_invalid = false
            this.ssn_required = false
            this.showone = false
          }
        }).catch(e => {
          console.log(e)
        })
      }
    },
    removeUploading (index) {
      this.files.splice(index, 1)
    },
    uploading (sid) {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      const formData = new FormData()
      formData.append('image', this.files[0])
      formData.append('sid', sid)
      formData.append('candidate_name', this.form.candidate_name)
      if (this.files.length > 0) {
        axios.post(BaseURL + '/dashboard/add_candidate_resume/' + sid + '/' + this.form.candidate_name,
          formData, config).then(response => {
          // window.location.href = '/Dashboard'
        }).catch(e => {
          console.log(e)
        })
      }
    },
    // uploading (sid) {
    //   console.log(this.files)
    //   const config = {
    //     headers: {
    //       'content-type': 'multipart/form-data'
    //     }
    //   }
    //   let formdata = {
    //     image: this.files[0],
    //     sid: sid,
    //     candidate_name: this.form.candidate_name
    //   }
    //   const formData = new FormData()
    //   for (let k = 0; k < this.files.length; k++) {
    //     formData.append('image', this.files[k])
    //   }
    //   if (this.files.length > 0) {
    //     axios.post(BaseURL + '/dashboard/add_candidate_resume',
    //       {formData: formdata}, config)
    //     .then(response => {
    //       // window.location.href = '/Dashboard'
    //     })
    //     .catch(e => {
    //       console.log(e)
    //     })
    //   }
    // },
    ValidateAlpha (event) {
      // event = (event) ? event : window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        return true
      } else {
        event.preventDefault()
      }
    },
    removeerrorp () {
      this.pskillerror = false
    },
    removeerrors () {
      this.Sskillerror = false
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    SendMessageToParent () {
      // this.$root.$emit('message_from_abc', this.selectpost)
      this.$root.$emit('message_from_tobe', this.selectpost)
    },
    scrollToElement () {
      const el = this.$el.getElementsByClassName('scroll-to-me')[0]
      if (el) {
        el.scrollIntoView()
      }
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
    },
    changeTimeZone (id, timezone, types) {
      var mainurl = ''
      console.log(timezone)
      const listtime = timezonList.find(item => { return String(item.fullName) === String(timezone) })
      console.log(listtime)
      this.activetimezone = listtime.name
      const currentTime = timezonList.find(item => { return String(item.fullName) === String(momentsone.tz.guess()) })
      if (this.showRole) {
        mainurl = '/dashboard/get_user_availability_acs/web/' + id + '/' + listtime.name + '/' + currentTime.name
      } else {
        mainurl = '/dashboard/get_user_availability/web/' + id
      }
      this.intestpoput = true
      this.validationerrorre = false
      this.timezoneDates = []
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.timezoneDates = response.data.availabilityDetails
        this.currentTimeZone = listtime.fullName
        this.timezone = listtime.name
        this.groupeddatelen = response.data.availabilityDetails.length
        for (let index = 0; index < this.timezoneDates.length; index++) {
          const Start = this.timezoneDates[index].startdatetime_utc
          console.log(momentsone.utc(Start).tz(timezone).format('DD-MM-YYYY HH:mm a'))
          this.timezoneDates[index].utc_start = this.timezoneDates[index].start_datetime
          this.timezoneDates[index].utc_start_time = moment(this.timezoneDates[index].start_datetime).format('HH:mm:ss')
          this.timezoneDates[index].utc_date = moment(this.timezoneDates[index].startdate).format('YYYY-MM-DD')
          this.timezoneDates[index].utc_end = this.timezoneDates[index].end_datetime
          this.timezoneDates[index].utc_end_time = moment(this.timezoneDates[index].end_datetime).format('HH:mm:ss')
          this.timezoneDates[index].start_datetime = momentsone.utc(Start).tz(timezone).format('DD-MM-YYYY HH:mm a')
          this.timezoneDates[index].startdate = momentsone.utc(Start).tz(timezone).format('DD-MMM-YYYY')
          this.timezoneDates[index].start_time = momentsone.utc(Start).tz(timezone).format('hh:mm a')
          this.timezoneDates[index].startdate1 = momentsone.utc(Start).tz(timezone).format('YYYY-MM-DD')
          this.timezoneDates[index].start_time1 = momentsone.utc(Start).tz(timezone).format('HH:mm:ss')
          this.timezoneDates[index].start_datetime1 = momentsone.utc(Start).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
          const End = this.timezoneDates[index].enddatetime_utc
          this.timezoneDates[index].end_datetime = momentsone.utc(End).tz(timezone).format('DD-MM-YYYY HH:mm a')
          this.timezoneDates[index].end_time = momentsone.utc(End).tz(timezone).format('hh:mm a')
          this.timezoneDates[index].end_time1 = momentsone.utc(End).tz(timezone).format('HH:mm:ss')
          this.timezoneDates[index].end_datetime1 = momentsone.utc(End).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
        }
        this.groupBy(this.timezoneDates, 'startdate')
      }).catch(e => {
        console.log(e)
      })
    },
    getdatetime (start) {
      console.log(start)
      this.changed = 1
      this.disableasign = false
      this.shownewdate = true
      this.validationerror = false
      this.startdate = start
      $('#' + start.start_datetime).attr('checked', true)
      this.getScheduleDetails()
    },
    changeEmail () {
      this.emailval_error = false
    },
    close () {
      this.$emit('input', false)
    },
    getdata () {
      const id = this.userInfo._id
      this.changeTimeZone(this.userid, this.org_timezone, 0)
      const mainurl = '/dashboard/get_profile_detail/' + this.userid + '/' + this.selectpost + '/' + id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.profiledetails = response.data.profileDetail[0]
        this.profilesills = response.data.profileSkillList
        this.schedule_count = response.data.schedule_count
        this.interviewer_timezone_short = this.profiledetails.timezone
        const listtime = timezonList.find(item => { return String(item.name) === String(this.interviewer_timezone_short) })
        this.interviewer_timezone = listtime.fullName
        if (response.data.schedule_count > 0) {
          this.startdate = ''
          this.disableasign = true
        } else {
          this.startdate = ''
          this.disableasign = true
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getpostdata () {
      const mainurl = '/dashboard/get_post_details/ios/' + this.selectpost + '/' + this.userid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.postdetails = response.data.interviewerList[0]
      }).catch(e => {
        console.log(e)
      })
    },
    checkUniqueId () {
      const mainurl = '/dashboard/check_candidate_uniqueid'
      const data = {
        candidate_email: this.form.candidate_email,
        candidate_uniqueid: this.form.candidate_uniqueid
      }
      axios.post(`${this.base_urls}${mainurl}`, { formData: data }, this.config).then(response => {
        if (response.data.message === 'Candidate uniqueid already exist') {
          this.unique_exist = true
        }
      }).catch(e => {
        console.log(e)
      })
    },
    checkSSNId () {
      const mainurl = '/dashboard/check_candidate_ssn'
      const data = {
        candidate_email: this.form.candidate_email,
        candidate_ssn: this.form.candidate_ssn
      }
      axios.post(`${this.base_urls}${mainurl}`, { formData: data }, this.config).then(response => {
        if (response.data.message === 'Candidate ssn already exist') {
          this.ssn_exist = true
        }
      }).catch(e => {
        console.log(e)
      })
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    changeUnique () {
      this.unique_required = false
      this.unique_invalid = false
      this.unique_exist = false
      this.ssn_exist = false
      this.ssn_invalid = false
      this.ssn_required = false
      this.showone = false
      if (this.form.candidate_uniqueid === 'NA' || this.form.candidate_uniqueid === 'Na') {
        this.form.candidate_uniqueid = ''
      }
      if (this.form.candidate_ssn === 'NA' || this.form.candidate_ssn === 'Na') {
        this.form.candidate_ssn = ''
      }
      if (this.form.candidate_uniqueid && this.form.candidate_ssn) {
        this.showone = true
        this.editoptionssn = false
        this.editoption = false
        return false
      } else if (!this.form.candidate_uniqueid && !this.form.candidate_ssn) {
        this.unique_required = true
        this.editoptionssn = false
        this.editoption = false
        return false
      } else if (this.form.candidate_uniqueid) {
        if (this.form.candidate_uniqueid.length !== 4) {
          this.unique_invalid = true
          return false
        } else if (this.form.candidate_uniqueid.length === 4) {
          this.editoptionssn = true
          this.checkUniqueId()
        }
      } else if (this.form.candidate_ssn) {
        if (this.form.candidate_ssn.length !== 4) {
          this.ssn_invalid = true
          return false
        } else if (this.form.candidate_ssn.length === 4) {
          this.editoption = true
          this.checkSSNId()
        }
      }
    },
    onSubmitProfile (typetext) {
      const listtime = timezonList.find(item => { return String(item.fullName) === String(this.currentTimeZone) })
      this.timezone = listtime.name
      this.typetext = typetext
      this.unique_required = false
      this.unique_invalid = false
      if (this.files.length < 1) {
        $('.custom-file-uploads').addClass('is-invalid')
        this.filerequire = 1
      }
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      if (this.showRole && !this.acsallow) {
        if (this.form.candidate_uniqueid && this.form.candidate_ssn) {
          this.showone = true
          return false
        } else if (!this.form.candidate_uniqueid && !this.form.candidate_ssn) {
          this.unique_required = true
          return false
        } else if (this.form.candidate_uniqueid) {
          if (this.form.candidate_uniqueid.length !== 4) {
            this.unique_invalid = true
            return false
          } else if (this.unique_exist) {
            return false
          }
        } else if (this.form.candidate_ssn) {
          if (this.form.candidate_ssn.length !== 4) {
            this.ssn_invalid = true
            return false
          } else if (this.ssn_exist) {
            return false
          }
        }
        this.checkSchedule()
      }
      if (this.showRole && this.acsallow) {
        this.form.year_of_experience = 0
        this.form.month_of_experience = 0
        if (!this.form.candidate_name && !this.form.candidate_email) {
          return false
        }
        if (this.profiledetails.user_email === this.form.candidate_email) {
          this.emailval_error = true
          return false
        }
        if (this.files.length < 1) {
          $('#custom-file-upload').addClass('is-invalid')
          this.filerequire = 1
          return false
        }
        this.filerequire = 0
        this.$nextTick(() => {
          this.postdatas = []
          // if (this.schedule_count > 0 || this.changed === 1) {
          console.log(this.startdate)
          console.log(this.startdate.start_datetime)
          console.log(this.startdate.start_datetime1)
          // this.profiledetails.start_time = moment(this.startdate.start_datetime).format('HH:mm:ss')
          // this.profiledetails.end_time = moment(this.startdate.end_datetime).format('HH:mm:ss')
          // this.profiledetails.startdate = moment(this.startdate.start_datetime).format('YYYY-MM-DD')
          // this.profiledetails.start_datetime = moment(this.startdate.start_datetime).format('YYYY-MM-DD HH:mm:ss')
          // this.profiledetails.end_datetime = moment(this.startdate.end_datetime).format('YYYY-MM-DD HH:mm:ss')
          // }
          this.postdatas = {
            post_id: this.selectpost,
            user_id: this.profiledetails._id,
            org_id: this.userInfo._id,
            _id: this.scheduleId,
            candidate_name: this.form.candidate_name,
            candidate_lastname: this.form.candidate_lastname,
            candidate_email: this.form.candidate_email,
            user_email: this.profiledetails.user_email,
            year_of_experience: this.form.year_of_experience,
            month_of_experience: this.form.month_of_experience,
            comments: this.form.comments,
            schedule_date: this.startdate.startdate1,
            schedule_start_time: this.startdate.start_time1,
            schedule_end_time: this.startdate.end_time1,
            start_datetime: this.startdate.start_datetime1,
            end_datetime: this.startdate.end_datetime1,
            others: this.otheremailList,
            candidate_uniqueid: this.form.candidate_uniqueid,
            candidate_ssn: this.form.candidate_ssn,
            schedule_timezone: this.activetimezone,
            schedule_interviewer_timezone: this.interviewer_timezone_short,
            schedule_org_timezone: this.org_timezone_short
          }
          if (this.scheduleId === '') {
            delete this.postdatas._id
          }
          this.shedulesuccess = 1
          let mainurl = '/dashboard/add_schedule_web_multiple_candidate_acs'
          if (this.showRole) {
            if (this.typetext === 'save') {
              mainurl = '/dashboard/save_schedule_acs'
            } else {
              mainurl = '/dashboard/add_schedule_web_multiple_candidate_acs'
            }
          } else {
            mainurl = '/dashboard/add_schedule_web_multiple_candidate'
          }
          axios.post(BaseURL + mainurl, { formData: this.postdatas }, this.config).then(response => {
            if (this.typetext === 'save') {
              this.$awn.success('Saved Successfully')
            } else {
              this.$awn.success('Scheduled Successfully')
            }
            const id = response.data.results._id
            this.uploading(id)
            this.primaryskillsend(id)
            this.secondaryskillsend(id)
            this.close()
          })
        })
      }
      if (this.validate()) {
        if (this.profiledetails.user_email === this.form.candidate_email) {
          this.emailval_error = true
          return false
        }
        if (this.files.length < 1) {
          $('#custom-file-upload').addClass('is-invalid')
          this.filerequire = 1
          return false
        }
        this.filerequire = 0
        this.$nextTick(() => {
          this.postdatas = []
          // if (this.schedule_count > 0 || this.changed === 1) {
          // this.profiledetails.start_time = this.startdate.utc_start_time
          // this.profiledetails.end_time = this.startdate.utc_end_time
          // this.profiledetails.startdate = this.startdate.utc_date
          // this.profiledetails.start_datetime = this.startdate.utc_start
          // this.profiledetails.end_datetime = this.startdate.utc_end
          console.log(this.startdate)
          // this.profiledetails.start_time = moment(this.startdate.start_datetime).format('HH:mm:ss')
          // this.profiledetails.end_time = moment(this.startdate.end_datetime).format('HH:mm:ss')
          // this.profiledetails.startdate = moment(this.startdate.start_datetime).format('YYYY-MM-DD')
          // this.profiledetails.start_datetime = moment(this.startdate.start_datetime).format('YYYY-MM-DD HH:mm:ss')
          // this.profiledetails.end_datetime = moment(this.startdate.end_datetime).format('YYYY-MM-DD HH:mm:ss')
          // }
          this.postdatas = {
            post_id: this.selectpost,
            user_id: this.profiledetails._id,
            org_id: this.userInfo._id,
            candidate_name: this.form.candidate_name,
            candidate_email: this.form.candidate_email,
            user_email: this.profiledetails.user_email,
            year_of_experience: this.form.year_of_experience,
            month_of_experience: this.form.month_of_experience,
            comments: this.form.comments,
            schedule_date: this.startdate.startdate1,
            schedule_start_time: this.startdate.start_time1,
            schedule_end_time: this.startdate.end_time1,
            start_datetime: this.startdate.start_datetime1,
            end_datetime: this.startdate.end_datetime1,
            candidate_uniqueid: this.form.candidate_uniqueid,
            candidate_ssn: this.form.candidate_ssn,
            schedule_timezone: this.activetimezone,
            schedule_interviewer_timezone: this.interviewer_timezone_short,
            schedule_org_timezone: this.org_timezone_short
          }
          this.shedulesuccess = 1
          axios.post(BaseURL + '/dashboard/add_schedule_web_multiple_candidate', {
            formData: this.postdatas
          }, this.config).then(response => {
            this.$awn.success('Scheduled Successfully')
            const id = response.data.results._id
            this.uploading(id)
            this.primaryskillsend(id)
            this.secondaryskillsend(id)
            this.close()
          })
        })
      } else {
        console.log('validation fail................')
      }
    },
    getScheduleDetails () {
      const mainurl = '/dashboard/get_schedule_detail_acs'
      this.profiledetails.start_time = this.startdate.utc_start_time
      this.profiledetails.end_time = this.startdate.utc_end_time
      this.profiledetails.startdate = this.startdate.utc_date
      this.profiledetails.start_datetime = this.startdate.utc_start
      this.profiledetails.end_datetime = this.startdate.utc_end
      const postdatas = {
        post_id: this.selectpost,
        user_id: this.profiledetails._id,
        org_id: this.userInfo._id,
        start_datetime: this.profiledetails.start_datetime,
        end_datetime: this.profiledetails.end_datetime
      }
      axios.post(BaseURL + mainurl, { formData: postdatas }, this.config).then(response => {
        this.acsscheduleDetail = response.data.results
        this.acsscheduleDetaillength = this.acsscheduleDetail.length
        if (this.acsscheduleDetaillength > 0) {
          const data = this.acsscheduleDetail[0]
          this.scheduleId = data._id
          this.form.candidate_name = data.candidate_name
          this.form.candidate_lastname = data.candidate_lastname
          this.form.candidate_email = data.candidate_email
          this.form.candidate_uniqueid = data.candidate_uniqueid
          this.form.candidate_ssn = data.candidate_ssn
          this.form.year_of_experience = data.year_of_experience
          this.form.month_of_experience = data.month_of_experience
          this.form.comments = data.comments
          let timezone = ''
          if (data.schedule_timezone === 'EST') {
            timezone = 'America/New_York'
          } else {
            timezone = 'Asia/Calcutta'
          }
          this.profiledetails.start_datetime = momentsone(data.start_datetime).tz(timezone).format('DD-MM-YYYY HH:mm a')
          this.profiledetails.end_datetime = momentsone(data.end_datetime).tz(timezone).format('DD-MM-YYYY HH:mm a')
          this.profiledetails.startdate = momentsone(data.start_datetime).tz(timezone).format('DD-MM-YYYY')
          this.profiledetails.start_time = momentsone(data.start_datetime).tz(timezone).format('HH:mm a')
          this.profiledetails.end_time = momentsone(data.end_datetime).tz(timezone).format('HH:mm a')
          const dataResume = {
            name: data.candidate_resume
          }
          this.files.push(dataResume)
          this.removeUploading(1)
        }
      })
    },
    clickyes () {
      this.showratingform = false
      this.acsallow = true
      this.onSubmitProfile(this.typetext)
    },
    checkSchedule () {
      this.form.year_of_experience = 0
      this.form.month_of_experience = 0
      if (!this.form.candidate_name && !this.form.candidate_email) {
        return false
      }
      if (this.profiledetails.user_email === this.form.candidate_email) {
        this.emailval_error = true
        return false
      }
      if (this.files.length < 1) {
        $('#custom-file-upload').addClass('is-invalid')
        this.filerequire = 1
        return false
      }
      this.showratingform = false
      this.postdatas = {
        candidate_emailid: this.form.candidate_email,
        org_id: this.userInfo._id
      }
      this.submitted = true
      axios.post(BaseURL + '/dashboard/check_candidate_schedule_acs', {
        formData: this.postdatas
      }, this.config).then(response => {
        this.alreadySchedule = response.data.schedule_detail
        this.alreadyScheduleLength = this.alreadySchedule.length
        this.previous_schedule_detail = response.data.previous_schedule_detail
        this.previous_schedule_detail_length = response.data.previous_schedule_detail.length
        this.showgetrating()
      })
    },
    showgetrating () {
      this.showratingform = true
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    primaryskillsend (id) {
      const postdata = []
      let k = 0
      for (k = 0; k < this.form.primarySkils.length; k++) {
        const data = {
          schedule_id: id,
          candidate_name: this.form.candidate_name,
          skill_id: this.form.primarySkils[k].id,
          skill_name: this.form.primarySkils[k].name
        }
        postdata.push(data)
      }
      axios.post(BaseURL + '/dashboard/add_schedule_primary_skill/' + id, {
        formData: postdata
      }, this.config).then(response => {
        // let id = response.data
      })
    },
    secondaryskillsend (id) {
      const postdata = []
      let k = 0
      for (k = 0; k < this.form.secoundarySkills.length; k++) {
        const data = {
          schedule_id: id,
          candidate_name: this.form.candidate_name,
          skill_id: this.form.secoundarySkills[k].id,
          skill_name: this.form.secoundarySkills[k].name
        }
        postdata.push(data)
      }
      axios.post(BaseURL + '/dashboard/add_schedule_secondary_skill/' + id, {
        formData: postdata
      }, this.config).then(response => {
        // let id = response.data
        // this.interviewermail(id)
        // this.SendMessageToParent()
      })
    },
    interviewermail (id) {
      this.postdatas = []
      this.postdatas = {
        post_id: this.selectpost,
        scheduleid: id,
        user_email: this.userInfo.user_email,
        start_datetime: this.profiledetails.start_datetime,
        end_datetime: this.profiledetails.end_datetime
      }
      axios.post(BaseURL + '/dashboard/send_mail_to_interviewer', {
        formData: this.postdatas
      }, this.config).then(response => {
        this.close()
      })
    },
    // getavailabledate (id) {
    //   var mainurl = ''
    //   console.log(this.showRole)
    //   if (this.showRole) {
    //     mainurl = '/dashboard/get_user_availability_acs/web/' + id
    //   } else {
    //     mainurl = '/dashboard/get_user_availability/web/' + id
    //   }
    //   this.intestpoput = true
    //   this.validationerrorre = false
    //   axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
    //     console.log(response.data)
    //     this.availabledate = response.data.availabilityDetails
    //     this.groupeddatelen = response.data.availabilityDetails.length
    //     this.changeTimeZone(this.currentTimeZone)
    //   }).catch(e => {
    //     console.log(e)
    //   })
    // },
    getTime (time) {
      return moment('19 Oct 2017 ' + time).format('HH:mm a')
    },
    enterEmail () {
      const data = {
        emailid: this.otherEmails
      }
      this.otheremailList.push(data)
      this.otherEmails = ''
    },
    removeEmail (index) {
      this.otheremailList.splice(index, 1)
    },
    getDate (date) {
      // const Start = moment.utc(date)
      const Start = moment(date).utc()
      return momentsone(Start).tz(this.currentTimeZone).format('DD MMM YYYY')
    },
    getScheduleTime (date) {
      // const Start = moment.utc(date)
      const Start = moment(date).utc()
      return momentsone(Start).tz(this.currentTimeZone).format('hh:mm a')
    }
  }
}
</script>

<template>
<!-- <div class="custom-modal-backdrop" v-show="shwovalueAddSchedule">  -->
  <div class="modal fade1 in" id="modal-default" style="display: block;" :v-show="Boolean(shwovalueAddSchedule)">
  <div class="modal-dialog" style="padding-top: 5%;">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close">
          <span aria-hidden="true" @click="close()">×</span></button>
        <h4>Schedule</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <div >
              <div class="direct-chat-info clearfix">
                <span class="direct-chat-name pull-left">
                  <span style="color:#999;font-weight: 400;font-size:12px">Job Title/ Designation</span>
                  <span><h5 class="mt-0 mb-7 c-g">{{postdetails.job_tittle}}</h5></span><br>
                  <span class="skill-title">Skillset</span>
                  <span class="skill-value mb-2">{{postdetails.primaryskillnames}}</span><br>
                  <span class="skill-title">Interview Type</span>
                  <span class="skill-value">{{postdetails.job_interview_type}}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-8 p-1 pull-right gray-details">
            <div class="direct-chat-messages">
              <b>Interviewer</b>
              <hr>
              <div class="direct-chat-msg">
                <img v-if="profiledetails.profile_picture !='' && profiledetails.profile_picture !=null" :src="`${profiledetails.profile_picture}`" class="direct-chat-img">
                <img v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == null" src="../../assets/img/default.png" class="direct-chat-img">
                <img v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'Female'" src="../../assets/img/female_default.png" class="direct-chat-img">
                <img v-if="profiledetails.profile_picture =='' || profiledetails.profile_picture ==null && profiledetails.gender == 'Male'" src="../../assets/img/male_default.png" class="direct-chat-img">
                <div class="direct-chat-info clearfix">
                  <span class="direct-chat-name pull-left ml-5">{{profiledetails.first_name}} {{profiledetails.last_name}}</span><br>
                    <span style="color:#999;font-weight: 400;" class="ml-5">Skillset : <span v-for="(item, i) in profilesills" :key="i">
                    {{(item !='' && i !=0) ? ',' : ''}} {{item.skill_desc}}
                    </span></span>
                  <span class="direct-chat-timestamp pull-right" style="width:25%"><star-rating class="pull-right" style="width:75%" active-color="#5bad2b" :show-rating="false" v-bind:increment="0.5" v-bind:star-size="15" :rating="Number(profiledetails.interviewer_rating)" :read-only="true"></star-rating></span>
                </div>
                <div class="direct-chat-info clearfix  mt-5">
                  <!-- <div v-if="schedule_count < 1"> -->
                    <button v-if="Boolean(showRole)" class="btn btn-default btn-xs btns pull-left">Experience : {{profiledetails.experience}} </button>
                    <button v-if="!Boolean(showRole)" class="btn btn-default btn-xs btns pull-left">Experience : {{profiledetails.experience}} | <i class="uil uil-rupee-sign"></i>{{profiledetails.interview_cost}} / Interview</button>
                    <!-- <div class="dropdown">
                      <a style="line-height: 2;" class="button dropdown-toggle btn-align sbtn btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{profiledetails.start_time}} to {{profiledetails.end_time}}</a>
                      <div class="pull-right with-date" style="width: 16%;">
                        <span>{{profiledetails.startdate | formatDate}}</span><br>
                        <span>{{profiledetails.startdate | getDay}}</span>
                      </div>
                    </div> -->
                  <!-- </div> -->
                </div>
              </div>
            </div>
            <div class="dropdown mt-2 pull-right">
                    <button v-if="!startdate" class="btn btn-success dropdown-toggle" id="menu1" type="button" data-toggle="dropdown" style="margin-top: -90px;
    margin-right: 10px;padding: 4px 4px 4px 4px;"><span v-if="!startdate">Select Time
                      <span class="caret"></span></span>
            <div v-if="startdate">
              <a style="line-height: 2;padding: 6px 5px 4px 4px;width: 66%;" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{startdate.start_time}} to {{startdate.end_time}} <i class="uil uil-edit-alt"></i></a>
              <div class="pull-right with-date" style="width: 34%;color: #5bad2b;padding-left: 0px !important;
border: 1px solid #dddddd87;">
                <span>{{startdate.startdate | formatDate}}</span><br>
                <span>{{startdate.startdate | getDay}}</span>
              </div>
            </div>
            </button>
            <button v-if="startdate" class="btn btn-success dropdown-toggle" id="menu1" type="button" data-toggle="dropdown" style="margin-top: -85px;
margin-right: 10px;padding: 2px 2px 2px 2px;"><span v-if="!startdate">Select Time
            <span class="caret"></span></span>
            <div v-if="startdate">
            <a style="line-height: 2;padding: 6px 5px 4px 4px;width: 66%;" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{startdate.start_time}} to {{startdate.end_time}} <i class="uil uil-edit-alt"></i></a>
            <div class="pull-right with-date" style="width: 34%;color: black;padding-left: 0px !important;
border: 1px solid #dddddd87;">
              <span>{{startdate.startdate | formatDate}}</span><br>
              <span>{{startdate.startdate | getDay}}</span>
            </div>
          </div>
            </button>
            <!-- <button v-if="!shownewdate" class="btn btn-success dropdown-toggle" id="menu1" type="button" data-toggle="dropdown" style="margin-top: -85px;
margin-right: 10px;padding: 2px 2px 2px 2px;"><span v-if="!startdate">Select Time
            <span class="caret"></span></span>
            <div v-if="startdate">
            <a style="line-height: 2;padding: 6px 5px 4px 4px;width: 66%;" class="button btn-align sbtn btn-sm accent-btn rounded raised pull-right"><i class="fa fa-clock-o" aria-hidden="true"></i> {{profiledetails.start_time}} to {{profiledetails.end_time}} <i class="uil uil-edit-alt"></i></a>
            <div class="pull-right with-date" style="width: 34%;color: black;padding-left: 0px !important;
border: 1px solid #dddddd87;">
              <span>{{profiledetails.startdate | formatDate}}3</span><br>
              <span>{{profiledetails.startdate | getDay}}</span>
            </div>
          </div>
            </button> -->
              <div class="col-md-12 dropdown-menu selecttime" style="width: 535px;" role="menu" aria-labelledby="menu1">
                <div v-if="groupeddatelen < 1" class="row mt-2 tc" style="color:#aaa8a8;padding: 15px;">Interviewer has no available time!</div>
                <div class="row mt-2" v-for="(date, index) in groupeddate" :key="index">
                  <div class="col-md-2 p-1 tc">{{index}} <br> {{index | getDay}}</div>
                  <div class="col-md-10">
                    <ul class="donate-now mt-0">
                      <li v-for="(d, ind) in date" :key="ind" v-bind:class="[{'disabled': d.disabledtag}, {'orange-btn': d.orange_tag == 'Yes' && !d.disabledtag}]" style="width: 136px;height: 33px;" @click="getdatetime(d)">
                        <input type="radio" :id="d.start_datetime" name="time" />
                        <label :for="d.start_datetime">{{d.start_time}} - {{d.end_time}}</label>
                      </li>
                    </ul>
                  </div>
              </div>
              </div>
            </div>
          </div>
          <div class="col-md-12" v-if="Boolean(showRole)">
            <div class="dropdown" style="float:right;margin-top: -15px;display: inline-flex;">
              <label style="margin-top: 7px;margin-right: 10px;">TimeZone: </label>
              <!-- <button class="btn btn-default" type="button" data-toggle="dropdown">{{timezone}} -->
              <!-- <span class="caret"></span></button> -->
              <button class="btn mr-2" @click="changeTimeZone(profiledetails._id, org_timezone, 1)" v-if="org_timezone_short != interviewer_timezone_short" v-bind:class="{'btn-success': org_timezone_short == activetimezone }">{{org_timezone_short}}</button>
              <button class="btn" @click="changeTimeZone(profiledetails._id, interviewer_timezone, 1)" v-if="org_timezone_short != interviewer_timezone_short" v-bind:class="{'btn-success': interviewer_timezone_short == activetimezone }">{{interviewer_timezone_short}}</button>
              <button class="btn btn-success" @click="changeTimeZone(profiledetails._id, interviewer_timezone, 1)" v-if="org_timezone_short == interviewer_timezone_short">{{interviewer_timezone_short}}</button>
              <!-- <ul class="dropdown-menu" style="min-width: 102px;">
                <li @click="changeTimeZone(profiledetails._id, 'Asia/Calcutta')"><a>IST</a></li>
                <li @click="changeTimeZone(profiledetails._id, 'America/New_York')"><a>EST</a></li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="row" v-if="tabOne">
          <hr>
          <div class="col-md-12" :disabled="Boolean(disableasign)" v-bind:class="{'asigncandidate': Boolean(disableasign) }">
            <h4>Assign Candidate</h4>
            <hr>
            <!-- start form -->
            <b-form class="register-form" novalidate>
                <div class="form-row" v-if="Boolean(showRole)">
                  <div class="form-group">
                    <label>Resume</label>
                      <div class="custom-file-uploads">
                        <div v-if="files.length < 1" class="show-doc-empty">Upload candidate resume *</div>
                        <div class="show-doc" v-if="files.length > 0">
                          <span class="doc-file pull-left" v-for="(x, i) in files.slice(0, 2)" :key="i"><span class="doc-name">{{x.name}} </span><i @click="removeUploading(x)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                        </div>
                        <label for="files"><i class="fa fa-upload" aria-hidden="true"></i> Upload </label>
                        <input @change="fileUploads($event)" style="visibility:hidden;" type="file" id="files" name="files"/>
                    </div>
                    <span style="color: #aeaaaa;">Supported format (.pdf,.docx), Size (Max 2MB)</span>
                    <div v-if="filerequire == 1">
                      <p class="login-alert-msg error-content">* Select the file</p>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label v-if="!Boolean(showRole)">Candidate Name</label>
                    <label v-if="Boolean(showRole)">Candidate First Name</label>
                    <b-form-input v-model.lazy.trim="$v.form.candidate_name.$model" type="text" placeholder="Candidate Name *" :state="chkState('candidate_name')"/>
                    <div v-if="$v.form.candidate_name.$error">
                      <p v-if="!$v.form.candidate_name.required" class="login-alert-msg error-content">* Enter Candidate Name</p>
                    </div>
                  </div>
                  <div class="form-group" v-if="showRole">
                    <label>Candidate Last Name</label>
                    <b-form-input v-model.lazy.trim="$v.form.candidate_lastname.$model" type="text" placeholder="Candidate Last Name *" :state="chkState('candidate_lastname')"/>
                    <div v-if="$v.form.candidate_lastname.$error">
                      <p v-if="!$v.form.candidate_lastname.required" class="login-alert-msg error-content">* Enter Candidate Last Name</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <b-form-input id="candidate_email" v-model.lazy.trim="$v.form.candidate_email.$model" @keyup="changeEmail()" type="text" placeholder="Candidate Email *" :state="chkState('candidate_email')"/>
                    <div v-if="$v.form.candidate_email.$error && !submitted">
                      <p v-if="!$v.form.candidate_email.required" class="login-alert-msg error-content">* Enter Candidate Email</p>
                      <p v-if="!$v.form.candidate_email.email" class="login-alert-msg error-content">* Enter a valid email</p>
                    </div>
                    <div v-if="emailval_error">
                      <p class="login-alert-msg error-content">* This email already used for interviewer</p>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="showRole">
                  <div class="form-group">
                    <label>Aadhar ( Last 4 digit )</label>
                    <b-form-input :disabled="editoption" v-model.lazy.trim="$v.form.candidate_uniqueid.$model" type="text" @keyup="changeUnique()" placeholder="Candidate Aadhar" v-bind:class="{'is-invalid': unique_required}"/>
                    <div>
                      <p v-if="showone" class="login-alert-msg error-content">* Please enter either Aadhar or SSN</p>
                      <p v-if="unique_required" class="login-alert-msg error-content">* Enter aadhar number</p>
                      <p v-if="unique_invalid" class="login-alert-msg error-content">* Aadhar should be 4 characters</p>
                      <p v-if="unique_exist" class="login-alert-msg error-content">* Aadhar is already exist.</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>SSN ( Last 4 digit )</label>
                    <b-form-input :disabled="editoptionssn" v-model.lazy.trim="$v.form.candidate_ssn.$model" type="text" @keyup="changeUnique()" placeholder="Candidate SSN" v-bind:class="{'is-invalid': ssn_required}"/>
                    <div>
                      <!-- <p v-if="ssn_required" class="login-alert-msg error-content">* Enter SSN number</p> -->
                      <p v-if="ssn_invalid" class="login-alert-msg error-content">* SSN should be 4 characters</p>
                      <p v-if="ssn_exist" class="login-alert-msg error-content">* SSN is already exist.</p>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="!showRole">
                  <div class="form-group">
                    <label>Experience</label>
                    <div class="form-row">
                      <div class="form-group">
                        <div class="form-select">
                          <select v-model="form.year_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('year_of_experience') }">
                            <option value=''>Select year *</option>
                            <option value="1">1 year</option>
                            <option v-for="x in 19" v-bind:value="x +1" :key="x">{{x + 1}} years</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div v-if="$v.form.year_of_experience.$error">
                          <p v-if="!$v.form.year_of_experience.required" class="login-alert-msg error-content">* Select the year</p>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="form-select">
                          <select v-model="form.month_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('month_of_experience') }">
                            <option value=''>Select month *</option>
                            <option value="0">0 month</option>
                            <option value="1">1 month</option>
                            <option v-for="x in 10" v-bind:value="x +1" :key="x">{{x + 1}} months</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div v-if="$v.form.month_of_experience.$error">
                          <p v-if="!$v.form.month_of_experience.required" class="login-alert-msg error-content">* Select the month</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Resume</label>
                      <div class="custom-file-uploads">
                        <div v-if="files.length < 1" class="show-doc-empty">Upload candidate resume *</div>
                        <div class="show-doc" v-if="files.length > 0">
                          <span class="doc-file pull-left" v-for="(x, i) in files.slice(0, 2)" :key="i"><span class="doc-name">{{x.name}} </span><i @click="removeUploading(x)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                        </div>
                        <label for="files"><i class="fa fa-upload" aria-hidden="true"></i> Upload </label>
                        <input @change="fileUploads($event)" style="visibility:hidden;" type="file" id="files" name="files"/>
                    </div>
                    <span v-if="!showrole" style="color: #aeaaaa;">Supported format (.pdf, .doc, .docx), Size (Max 2MB)</span>
                    <span v-if="showrole" style="color: #aeaaaa;">Supported format (.pdf), Size (Max 2MB)</span>
                    <div v-if="filerequire == 1">
                      <p class="login-alert-msg error-content">* Select the file</p>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="!showRole">
                  <div class="form-group">
                    <div class="form-select">
                      <label>Primary skills</label>
                      <multiselect :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.primarySkils" v-bind:class="{ 'is-invalid': !chkState('primarySkils') }" placeholder="Select primary skills*" label="name" track-by="name" :options="pSkils" :group-select="true" :multiple="true"></multiselect>
                    </div>
                    <div v-if="$v.form.primarySkils.$error">
                      <p v-if="!$v.form.primarySkils.required" class="login-alert-msg error-content">* Select the primary skills</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-select">
                      <label>Secondary skills</label>
                      <multiselect :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.secoundarySkills" v-bind:class="{ 'is-invalid': !chkState('secoundarySkills') }" placeholder="Select secondary skills" label="name" track-by="name" :options="pSkils" :group-select="true" :multiple="true"></multiselect>
                    </div>
                    <div v-if="$v.form.secoundarySkills.$error">
                      <p v-if="!$v.form.secoundarySkills.required" class="login-alert-msg error-content">* Select the secondary skills</p>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="!showRole">
                  <div class="form-group" style="width:100%">
                    <label>Remarks / Comments</label>
                    <!-- <b-form-input v-model.lazy.trim="$v.form.comments.$model" type="text" placeholder="Enter your comments*" :state="chkState('comments')"/> -->
                    <b-form-textarea v-model.lazy.trim="$v.form.comments.$model" :state="chkState('comments')" class="textarea" rows="3" placeholder="Enter your comments"></b-form-textarea>

                  </div>
                </div>
                <div class="form-row" v-if="showRole">
                  <div class="form-group" style="width:100%">
                    <label>Others</label>
                    <b-form-input id="othervalues" v-model="otherEmails" @keyup.enter="enterEmail()" type="email" required placeholder="Type the email and enter"/>
                  </div>
                </div>
                <span v-for="(item,i) in otheremailList" :key="i" class="emaillist">{{item.emailid}} <span @click="removeEmail(i)" style="color: #dd4b39;">X</span></span>
              <hr>
                <div class="form-submit">
                  <input type="button" @click="tabOne = false, tabTwo = true" value="Preview" class="submit mr-2 resetbtn" name="reset" id="submit" />
                  <input v-if="showRole" type="button" @click="onSubmitProfile('save')" value="Save" class="submit mr-2" name="submit" id="submit" />
                  <!-- <input :disabled="shedulesuccess == 1" type="button" @click="onSubmitProfile('submit')" value="Schedule" class="submit" name="submit" id="submit" /> -->
                  <input type="button" @click="onSubmitProfile('submit')" value="Schedule" class="submit" name="submit" id="submit" />
                </div>
              </b-form>
            <!-- form end -->
          </div>
        </div>
        <div class="row" v-if="tabTwo">
          <hr>
          <div class="col-md-11" style="left: 4%;background-color: #f5f5f5;">
            <h4 v-if="!showRole">Assign Candidate</h4>
            <hr>
            <!-- start form -->
            <div class="row" v-if="showRole">
              <b>Important instructions:</b><br>
              You are requested to login into the meeting 5 minutes prior to the scheduled time.<br>
              Panelist will share another meeting link, should there be any technical glitch with the initial link provided.<br>
              Please be in a quiet place.<br>
              Do not be driving and do not take this session on your mobile phone.<br>
              Have a laptop with a well-functioning camera.<br>
              Be ready to do screen sharing and pair programing / coding exercise. This is mandatory.<br>
              Allocate 45 to 60 minutes for this session.<br>
              Please accept the invitation as soon possible.<br>
              Kindly respond / reach out to us for any changes required with the schedule.<br>
              Post the assessment session, do not approach the panel member for any reasons including for feedback.<br><br>

              <b>Panel Details:</b><br>
              Panel member name: {{profiledetails.first_name}} {{profiledetails.last_name}}
              <table class="table table-bordered acstable">
                <tr>
                  <td>First Name: </td>
                  <td>{{$v.form.candidate_name.$model}}</td>
                </tr>
                <tr>
                  <td>Middle Name: </td>
                  <td>N/A</td>
                </tr>
                <tr>
                  <td>Last Name: </td>
                  <td>{{$v.form.candidate_lastname.$model}}</td>
                </tr>
                <tr>
                  <td>Contact details: Telephone / e mail / Skype: </td>
                  <td>{{$v.form.candidate_email.$model}}</td>
                </tr>
                <tr>
                  <td>Available for Interview: Date / time (EST / CST / MST / PST) / </td>
                  <td>{{startdate.startdate | formatDate}} {{startdate.start_time}} to {{startdate.end_time}} {{timezone}}</td>
                </tr>
                <tr>
                  <td>Client Name: </td>
                  <td v-if="postdetails.org_description">{{postdetails.client_name}}</td>
                  <td v-if="postdetails.org_description==''">NA</td>
                </tr>
                <tr>
                  <td>Medium of interview: (Skype / in-person / Hangout/ Web X)  </td>
                  <td>screenit</td>
                </tr>
              </table><br>
              Job Title: {{postdetails.job_tittle}}<br>
              Location: Remote<br>
              Duration: 8-10 months+ (high possible extension)<br><br>
              <b>Job Description:</b><br>
              <p v-if="postdetails.org_description">{{postdetails.org_description}}</p>
              <p v-if="postdetails.org_description ==''">NA</p>
              <b>Remarks:</b><br>
              <p v-if="postdetails.job_comments">{{postdetails.job_comments}}</p>
              <p v-if="postdetails.job_comments ==''">NA</p>
            </div>
            <div class="row" v-if="!showRole">
              <div class="col-md-12 mb-2">
                <div class="col-md-4">
                  <span class="text-g">Candidate Name</span>
                  <span class="text-title">{{form.candidate_name}}</span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Year of Experience</span>
                  <span class="text-title">{{form.year_of_experience}} years {{form.month_of_experience}} month</span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Interview Type</span>
                  <span class="text-title">{{postdetails.job_interview_type}}</span>
                </div>
              </div>
              <div class="col-md-12 mb-2">
                <div class="col-md-4">
                  <span class="text-g">Primary Skills</span>
                  <span class="text-title">
                    <span v-for="(item,i) in form.primarySkils" :key="i">
                    {{(item !='' && i !=0) ? ',' : ''}} {{item.name}}
                    </span>
                    </span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Secondary Skills</span>
                  <span class="text-title">
                    <span v-for="(item,i) in form.secoundarySkills" :key="i">
                    {{(item !='' && i !=0) ? ',' : ''}} {{item.name}}
                    </span>
                  </span>
                </div>
                <!-- <div class="col-md-4">
                  <span class="text-g">Resume</span>
                  <span class="text-title">sureshkumar</span>
                </div> -->
              </div>
              <div class="col-md-12 mb-2">
                <div class="col-md-4">
                  <span class="text-g">Job Description</span>
                  <span class="text-title">{{postdetails.org_description}}</span>
                </div>
                <div class="col-md-4">
                  <span class="text-g">Remarks/ Comments</span>
                  <span class="text-title">{{form.comments}}</span>
                </div>
              </div>
            </div>
            <!-- form end -->
          </div>
          <div class="col-md-12">
            <hr>
            <div class="form-submit">
              <input type="button" @click="tabOne = true, tabTwo = false" value="Back" class="submit mr-2 resetbtn" name="reset" id="submit" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
<div class="modal fade in" id="modal-default" style="display: block;" v-show="showratingform">
    <div class="modal-dialog" style="margin-top:15px">
      <div class="modal-content" style="width: 701px;">
        <div class="modal-body" style="padding:0px">
          <div class="row">
            <div class="col-md-12 mt-10" v-if="alreadyScheduleLength < 1">
              <div style="text-align: center;" v-if="typetext =='submit'"><h3>Are you sure you want to schedule?</h3></div>
              <div style="text-align: center;" v-if="typetext =='save'"><h3>Are you sure you want to save?</h3></div>
              <div style="float: right;padding: 10px;">
                <button class="btn btn-default" @click="showratingform = false, acsallow = false" style="margin-right: 8px;">No</button>
                <button class="btn btn-success" @click="clickyes()">Yes</button>
              </div>
            </div>
            <div class="col-md-12 mt-10" v-if="alreadyScheduleLength > 0">
              <!-- <div style="text-align: center;"><h3>Candidate already attented the interview.</h3></div> -->
              <!-- <div v-for="item in alreadySchedule" :key="item">
                <div class="col-md-12">
                  <div class="col-md-6"><label> Name:</label> {{item.candidate_name}}</div>
                  <div class="col-md-6"><label>Candidate Email:</label> {{item.candidate_email}}</div>
                </div>
                <div class="col-md-12">
                  <div class="col-md-6"><label>Schedule Date:</label> {{item.schedule_date | formatDate}}</div>
                  <div class="col-md-6"><label>Schedule Time:</label> {{getTime(item.schedule_start_time)}} - {{getTime(item.schedule_end_time)}}</div>
                </div>
              </div> -->
              <div class="col-md-12" v-if="previous_schedule_detail_length > 0">
                <div style="text-align: center;"><h3>Candidate's Schedule History.</h3></div>
                <hr>
                <table border="0" style="width: 100%;border: 0px solid #252424b8 !important;">
                  <tr style="border: 0px solid #252424b8;background-color: aliceblue;height: 32px;text-align: center;">
                    <td style="border: 0px solid #252424b8;"><b>Schedule Date</b></td>
                    <td style="border: 0px solid #252424b8;"><b>Schedule Time</b></td>
                    <td style="border: 0px solid #252424b8;"><b>Client's Name</b></td>
                    <td style="border: 0px solid #252424b8;"><b>Role considered for.</b></td>
                  </tr>
                  <tr v-for="(item1, ind) in previous_schedule_detail" :key="ind" style="height: 30px;border: 0px solid #252424b8;text-align: center;">
                    <td style="border: 0px solid #252424b8;">{{getDate(item1.schedule_date)}}</td>
                    <td style="border: 0px solid #252424b8;">{{getScheduleTime(item1.start_datetime)}} to {{getScheduleTime(item1.end_datetime)}} {{timezone}}</td>
                    <td style="border: 0px solid #252424b8;">{{item1.client_name}}</td>
                    <td style="border: 0px solid #252424b8;">{{item1.job_title}}</td>
                  </tr>
                </table>
              </div>
              <div style="float: right;padding: 10px;">
                <button class="btn btn-default" @click="showratingform = false, acsallow = false" style="margin-right: 8px;">No</button>
                <button class="btn btn-success" @click="clickyes()">Continue</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>
</div>
</template>
<style scoped>
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      width: 801px;
  }
}
.modal { overflow: auto !important; }
.modal-header {
  padding: 8px !important;
}
img {
    max-width: 84px;
    height: auto;
}
.modal-header {
  background-color: #F5F5F5;
  border-bottom: 1px solid #cccccc73;
}
.nav-tabs {
  border-bottom: 0;
  margin-bottom: 0;
  background-color: #f5f5f5;
}
.nav-tabs li {
  width:auto;
}
.nav-tabs li a {
  color:black;
}
.nav-tabs li.active a {
  background-color: #5bad2b;
  color: white;
}
.nav-tabs li.active a:hover {
  background-color: #5bad2b;
  color: white;
}
hr {
    border-top: 1px solid #55555538 !important;
}
hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.info-box {
  background-color: #f5f5f5 !important;
}
.bg-yellow {
  border-right: 5px solid white;
  background-color: #f5f5f5 !important;
}
.info-box-content {
    padding: 39px 10px;
    margin-left: 90px;
}
.info-box-number {
  font-size: 12px;
}
.resumeview {
  margin-top: 6px;
  margin-right: 20px;
  color: #5bad2b;
}
.f14 {
  font-size: 14px !important;
}
.cg {
  color: #5bad2b;
}
.c {
  text-align: center;
}
tr th {
  text-align: center;
}
.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.table>tbody>tr>td {
  padding: 4px;
}
.direct-chat-name.nametext {
  font-size: 14px;
  font-weight: 400;
}
.box-default {
  border: 1px solid #cccccc6e;
}
.box-header.chart {
  background-color: #f5f5f5;
  border: 1px solid #cccccc6e;
}

.button {
  cursor: pointer;
}
.gray-details .direct-chat-messages {
  background-color: #f5f5f5;
  border: 1px solid #cccccc8f;
  overflow: hidden;
  min-height: 130px;
  height: auto;
}
.ml-2 {
  margin-left: 10px;
}
.mt-2 {
    margin-top: 2px !important;
}
.mr-4 {
    margin-right: 4px !important;
}
.mt-4 {
    margin-top: 4px !important;
}
.mt-6 {
    margin-top: 6px !important;
}
.mt-5 {
    margin-top: 5px !important;
}
.mt-0 {
  margin-top: 0px;
}
.mb-7 {
  margin-bottom: -7px !important;
}
.skill-title {
  color: rgb(153, 153, 153);
  font-weight: 400;
  font-size: 12px;
}
.skill-value {
  color: #333;
  font-weight: 400;
  font-size: 14px;
}
.direct-chat-msg {
    margin-bottom: 0px;
}
.text-g {
  color: #a29d9d;
}
.text-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
  color: #5B5B5B;
}
img {
    max-width: 84px;
    height: 41px;
}
.custom-file-uploads {
  height: 40px;
  border: 1px solid #e7e7e7;
  opacity: 1;
}
.custom-file-uploads label {
  text-align: center;
  width: 30%;
  float: right;
  margin-top: 2px;
  margin-right: 2px;
  color: white;
  font-weight: 100;
  padding: 7px 2px 7px 0px;
  background-color: #5bad2b;
}
.show-doc {
  width: 68%;
  margin-top: 4px;
  float: left;
  height: 30px;
}
.doc-file {
  background: #F5F5F5 0% 0% no-repeat padding-box;
  border: 1px solid #E0E0E0;
  border-radius: 18px;
  opacity: 1;
  padding: 4px;
  /* display: flex !important; */
  width: 47%;
  margin-left: 2px;
  margin-top: 0px;
}
.doc-name {
  width: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
}
.doc-file .fa {
  margin-top: -17px;
  cursor: pointer;
  width: 10%;
  float: right;
  margin-right: 4px;
}
.show-doc-empty {
  width: 60%;
  float: left;
  margin-left: 10px;
  margin-top: 7px;
  color: #979797;
}
.custom-file-uploads.is-invalid {
  border: 1px solid red;
}
.selecttime {
  height: auto;
  max-height: 293px;
  overflow: overlay;
  overflow-x: scroll;
  width: 600px;
}
.asigncandidate {
  pointer-events: none !important;
  opacity: 0.4 !important;
}
.emaillist {
  width: fit-content;
  background-color: aliceblue;
  padding: 5px;
  border-radius: 14px;
  margin-right: 5px;
  cursor: pointer;
}
.table, th, td {
  border: 1px solid #252424b8;
}
.acstable td {
  width: 50%;
  padding-left: 11px;
}
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
.orange-btn label {
  background-color: #ffa50096;
  color: white;
  border: none;
}
</style>
